// Keep in sync with package.json (checked by tests/unit/version.test.ts).
export const SDK_VERSION = '0.1.3';
